@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(1_285_959_564)
internal val Res.plurals.filter_show_places: PluralStringResource by lazy {
      PluralStringResource("plurals:filter_show_places", "filter_show_places", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 10, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 82),
      ))
    }

@delegate:ResourceContentHash(-898_145_307)
internal val Res.plurals.menu_summary: PluralStringResource by lazy {
      PluralStringResource("plurals:menu_summary", "menu_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 388, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 364, 148),
      ))
    }

@delegate:ResourceContentHash(-1_300_721_533)
internal val Res.plurals.menu_summary_all_vegan: PluralStringResource by lazy {
      PluralStringResource("plurals:menu_summary_all_vegan", "menu_summary_all_vegan", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 89, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93, 102),
      ))
    }

@delegate:ResourceContentHash(-1_265_702_930)
internal val Res.plurals.menu_summary_vegetarian: PluralStringResource by lazy {
      PluralStringResource("plurals:menu_summary_vegetarian", "menu_summary_vegetarian", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 212, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196, 167),
      ))
    }

@delegate:ResourceContentHash(1_992_534_272)
internal val Res.plurals.nearby_count: PluralStringResource by lazy {
      PluralStringResource("plurals:nearby_count", "nearby_count", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 553, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 513, 80),
      ))
    }

@delegate:ResourceContentHash(24_075_270)
internal val Res.plurals.places_count: PluralStringResource by lazy {
      PluralStringResource("plurals:places_count", "places_count", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 646, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 594, 64),
      ))
    }

@delegate:ResourceContentHash(-846_286_587)
internal val Res.plurals.search_results: PluralStringResource by lazy {
      PluralStringResource("plurals:search_results", "search_results", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 707, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 659, 66),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("filter_show_places", Res.plurals.filter_show_places)
  map.put("menu_summary", Res.plurals.menu_summary)
  map.put("menu_summary_all_vegan", Res.plurals.menu_summary_all_vegan)
  map.put("menu_summary_vegetarian", Res.plurals.menu_summary_vegetarian)
  map.put("nearby_count", Res.plurals.nearby_count)
  map.put("places_count", Res.plurals.places_count)
  map.put("search_results", Res.plurals.search_results)
}
